import gql from 'graphql-tag';

export const GET_CUSTOMERS = gql`
  query GetCustomers($input: CustomersByAccountIdInput!) {
    customer {
      customersByAccountId(input: $input) {
        error
        success
        total
        list {
          accountId
          name
          contactName
          phone
          type
          lastContactDate #latestTransactionDate
          status
          totalRevenueAmount
          activeDealsNumber
          opportunitiesNumber
        }
      }
    }
  }
`;
